import { cn } from '@/utils/cn';

type DividerCardProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const DividerCardTitle = ({ children, className, ...props }: DividerCardProps) => (
  <div
    className={cn(
      'dark:bg-gray-550 bg-white_theme-100 py-[18px] pl-6 border-b dark:border-border-400 border-gray-250 w-full font-semibold text-base rounded-t-xl dark:text-white text-black',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export const DividerCardBody = ({ children, className, ...props }: DividerCardProps) => (
  <div className={cn('py-[18px] px-4 w-full', className)} {...props}>
    {children}
  </div>
);

export const DividerCard = ({ children, className, ...props }: DividerCardProps) => (
  <div className={cn('border dark:border-border-400 border-gray-250 rounded-xl', className)} {...props}>
    {children}
  </div>
);
